import { Component, effect, Signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GenericComponent } from '../generic/generic.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { Store } from '@ngxs/store';
import { ConcessioncontrolState, PrepareDataFromKeys } from '../../states/concessioncontrol.state';
import { combineLatest, distinctUntilChanged } from 'rxjs';
import { CC_CONSTANTS } from '../../assets/constants';
import { ENEDIS_QUALITY_KPIS } from '../../assets/keys';

const KEYS = [ENEDIS_QUALITY_KPIS];

interface QualityKpiData {
    organizationId?: string;
    year?: string;
    error?: boolean;

    commissioningRate?: number;
    unpaidDisconnectionCount?: number;
}

@UntilDestroy()
@Component({
    selector: 'app-enedis-quality',
    templateUrl: './enedis-quality.component.html',
    styleUrls: ['./enedis-quality.component.scss'],
})
export class EnedisQualityComponent extends GenericComponent {
    public texts = CC_CONSTANTS.enedisQuality.texts;

    public kpis: Signal<QualityKpiData[]> = this.store.selectSignal(
        ConcessioncontrolState.getDataByKey(ENEDIS_QUALITY_KPIS),
    ) as Signal<QualityKpiData[]>;

    constructor(
        private readonly route: ActivatedRoute,
        private readonly sidenavService: SidenavService,
        private readonly store: Store,
    ) {
        super(route, sidenavService, store);
    }

    ngOnInit() {
        // Every time currentOrganization or currentYear changes, we tell the store he has to ask for the data
        combineLatest([this._currentOrganization$, this._currentYear$])
            .pipe(untilDestroyed(this), distinctUntilChanged())
            .subscribe(() => {
                this.store.dispatch(new PrepareDataFromKeys({ keys: KEYS }));
            });
    }
}
